  /*
   * Anmerkung zur Bestellung im Warenkorb-Drawer auf-/zuklappen.
   * Vorher: bei jeder Warenkorb-Anfrage (liquid-ajax-cart:request-end) wurde
   * ein neuer Klick-Listener angehaengt - ohne Pruefung, ob der Knopf existiert.
   * Bei leerem Warenkorb gibt es ihn nicht -> Fehler im Event der Warenkorb-
   * Bibliothek -> der Drawer blieb nach dem ersten "In den Warenkorb" auf
   * "Dein Warenkorb ist leer". Und nach mehreren Anfragen hingen mehrere
   * Listener dran, die sich gegenseitig aufhoben.
   * Jetzt: ein einziger delegierter Listener, der mit jedem neu gerenderten
   * Drawer funktioniert.
   */
  document.addEventListener('click', function (event) {
    var toggleButton = event.target.closest && event.target.closest('#toggle-my-cart_note');
    if (!toggleButton) return;
    var descriptionDiv = document.getElementById('my-cart_note');
    if (!descriptionDiv) return;
    var isExpanded = descriptionDiv.classList.toggle('show');
    toggleButton.textContent = toggleButton.getAttribute(isExpanded ? 'data-hide-text' : 'data-show-text');
  });

  /*
   * Warenkorb-Drawer auf Produktseiten: Shopify liefert die angefragten
   * Sections (Drawer, Zaehler) in Warenkorb-Antworten nur, wenn sie im
   * Kontext der aufrufenden Seite gerendert werden koennen - auf
   * Produktseiten kam "sections: null" zurueck, der Drawer blieb leer.
   * Mit sections_url = Startseite der aktuellen Sprache klappt es ueberall.
   */
  document.addEventListener('liquid-ajax-cart:request-start', function (event) {
    var state = event.detail && event.detail.requestState;
    var body = state && state.requestBody;
    if (!body) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (body instanceof FormData || body instanceof URLSearchParams) {
      if (!body.has('sections_url')) body.set('sections_url', root);
    } else if (typeof body === 'object' && !body.sections_url) {
      body.sections_url = root;
    }
  });

  /*
   * Fehler beim Hinzufuegen (z. B. nicht genug auf Lager) am Produktformular
   * anzeigen - das hat bisher nur der zweite, doppelte Theme-Weg gemacht.
   */
  document.addEventListener('liquid-ajax-cart:request-end', function (event) {
    var state = event.detail && event.detail.requestState;
    if (!state || state.requestType !== 'add' || !state.responseData || state.responseData.ok) return;
    var body = state.responseData.body || {};
    var message = body.description || body.message;
    if (!message) return;
    document.querySelectorAll('.product-form__error-message-wrapper').forEach(function (wrapper) {
      var text = wrapper.querySelector('.product-form__error-message');
      if (text) text.textContent = message;
      wrapper.removeAttribute('hidden');
    });
  });

  /**
   * Code below is used for restoring a user's cart when being redirected from the configurator.
   */
  function tryRestoreCart() {
    let url = new URL(window.location.href);
    let cartDataRaw = url.searchParams.get('restore_cart');

    if (cartDataRaw == null) return;
    let cartData = JSON.parse(cartDataRaw);

    if (cartData == null) return;

    let formData = {
      'items': [],
      'attributes': {
          'using_configurator__': true
      }
    };

    if (cartData.total) {
      formData.attributes.configurator_cart_total__ = cartData.total;
    }

    for (let variantId in cartData) {
      if (variantId === 'total') continue;
      let quantity = cartData[variantId];

      formData.items.push({
        'id': variantId,
        'quantity': quantity
      })
    }

    // Clear items in cart
    fetch(`${window.Shopify.routes.root}cart/clear.js`, {
      method: 'POST'
    }).then(() => {
      // Add items to cart
      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(() => {
        // Remove restore_cart from url and reload to ensure UI cart is up-to-date
        url.searchParams.delete('restore_cart');

        if (cartData.discount_code) {
          window.location.href = '/discount/' + cartData.discount_code;
          return;
        }
        
        window.location.href = url.toString();
      })
    })
  }

  try {
    tryRestoreCart();
  } catch (ex) {
    console.error(`Error: tryRestoreCart: ${ex}`);
  }